const StatsCards = ({ overview }) => {
  const cards = [
    {
      title: "Total Tests",
      value: overview.totalTests || 0,
      icon: "fa-flask",
      color: "primary"
    },
    {
      title: "Today's Tests",
      value: overview.todayTests || 0,
      icon: "fa-chart-line",
      color: "success"
    },
    {
      title: "Pending Tests",
      value: overview.pendingTests || 0,
      icon: "fa-clock",
      color: "warning"
    },
    {
      title: "Completion Rate",
      value: `${overview.completionRate || 0}%`,
      icon: "fa-check-circle",
      color: "info"
    }
  ];

  return (
    <div className="row mb-4">
      {cards.map((card, index) => (
        <div key={index} className="col-lg-3 col-md-6 mb-3">
          <div className={`card border-${card.color} h-100`}>
            <div className="card-body text-center">
              <div className="fs-1 mb-2">
                <i className={`fas ${card.icon} text-${card.color}`}></i>
              </div>
              <h3 className={`text-${card.color} mb-1`}>{card.value}</h3>
              <p className="text-muted mb-0">{card.title}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;